/* Campaign-only entry. Shopify owns prices, gift discounts and parent/child removal. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var hit = 67691389517901;
  var mikro = 67691414093901;
  var guide = 67762855673933;
  var code = 'START90-DARCEK';
  var buttons = Array.from(document.querySelectorAll('#hit-start [data-start90-buy]'));
  var busy = false;

  async function request(path, body) {
    var response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Nabídku se nepodařilo přidat do košíku. Zkuste to znovu.');
    return result;
  }

  function note(button, message) {
    var output = button.parentElement.querySelector('.s90-cart-note');
    if (!output) {
      output = document.createElement('p');
      output.className = 's90-cart-note';
      output.setAttribute('role', 'alert');
      button.insertAdjacentElement('afterend', output);
    }
    output.textContent = message;
  }

  function codes(cart) {
    return (cart.discount_codes || []).filter(function (discount) { return discount.applicable; })
      .map(function (discount) { return discount.code; });
  }

  async function rollback(group, previousCodes) {
    var cart = await request('cart.js');
    // BXGY can split a qualifying quantity into several lines. Remove the whole new group.
    var added = cart.items.filter(function (item) {
      return item.properties && item.properties._iprobio_group === group;
    });
    var updates = {};
    added.forEach(function (item) { updates[item.key] = 0; });
    if (added.length) await request('cart/update.js', { updates: updates });
    await request('cart/update.js', { discount: previousCodes.join(',') });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', async function (event) {
      event.preventDefault();
      if (busy) return;
      busy = true;
      buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      note(button, 'Přidáváme ŠTART 90 do košíku…');
      var group = 's90-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
      var previousCodes = [];
      var attempted = false;
      try {
        var before = await request('cart.js');
        previousCodes = codes(before);
        var shared = { _iprobio_campaign: 'start90', _iprobio_group: group };
        attempted = true;
        await request('cart/add.js', { items: [
          { id: hit, quantity: 1, properties: Object.assign({}, shared, { 'Nabídka': 'ŠTART 90', 'Garance': '90 dní' }) },
          { id: mikro, quantity: 1, parent_id: hit, properties: Object.assign({}, shared, { _iprobio_gift: 'mikrobiom', 'Dárek': 'ŠTART 90' }) },
          { id: guide, quantity: 1, parent_id: hit, properties: Object.assign({}, shared, { _iprobio_gift: 'mapa', 'Dárek': 'ŠTART 90' }) }
        ] });
        var requestedCodes = previousCodes.filter(function (c) { return c.toUpperCase() !== code; }).concat(code);
        await request('cart/update.js', { discount: requestedCodes.join(',') });
        var cart = await request('cart.js');
        var added = cart.items.filter(function (item) { return item.properties && item.properties._iprobio_group === group; });
        var parent = added.find(function (item) { return item.variant_id === hit; });
        var gifts = added.filter(function (item) { return item.properties._iprobio_gift; });
        if (!parent || added.length !== 3 || gifts.length !== 2 || !gifts.every(function (gift) {
          return gift.quantity === 1 && gift.final_line_price === 0 && gift.parent_relationship && gift.parent_relationship.parent_key === parent.key;
        })) {
          throw new Error('Dárky se nepodařilo uplatnit zdarma. Zkontrolujte ostatní slevy v košíku a zkuste to znovu.');
        }
        window.location.assign(root + 'cart');
      } catch (error) {
        if (attempted) {
          try { await rollback(group, previousCodes); }
          catch (_) { note(button, 'Před pokračováním zkontrolujte košík. Nabídku se nepodařilo dokončit.'); return; }
        }
        note(button, error.message || 'Nabídku se nepodařilo přidat do košíku. Zkuste to znovu.');
      } finally {
        busy = false;
        buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
      }
    });
  });
}());
